import React from "react";
import { useParams } from "react-router-dom";
import ChartsPage from "./ChartsPage";

const StatsPageView = () => {
  const { id } = useParams();
  return <ChartsPage statsPageId={id} />;
};

export default StatsPageView;
